import Vue from 'vue'
import axios from 'axios'
export let BASEURL_PRO = '/blade-gateway/platform-uc'
// export let BASEURL_PRO = 'http://gateway.xhngyl.net/platform-uc/'
export let BASEURL_PRO2 = "http://adm.xhngyl.net/api/"
export let BASEURL_PRO_ENTERPRISE = "http://merchant.xhngyl.net"
export let BASEURL_PRO_GATEWAY = "/blade-gateway"
export let SERVICE_MANAGE = "/platform-manage"
export let download = 'dev'

var baseurl = ''
switch(process.env.srconfig){
    //生产环境
  case 'prod':
    baseurl = '/api'
    BASEURL_PRO = '/blade-gateway/platform-uc'
    // BASEURL_PRO = 'http://gateway.xhngyl.com/platform-uc/'
    BASEURL_PRO2 = "http://adm.xhngyl.com/api/"
    BASEURL_PRO_ENTERPRISE = "http://merchant.xhngyl.com"
    BASEURL_PRO_GATEWAY = "/blade-gateway"
    SERVICE_MANAGE = "/platform-manage"
    download = 'prod'
    break;
  //开发环境
  case 'local':
    baseurl = '/api'
    BASEURL_PRO = '/blade-gateway/platform-uc'
    // BASEURL_PRO = 'http://gateway.xhngyl.net/platform-uc/'
    BASEURL_PRO2 = "http://adm.xhngyl.net/api/"
    BASEURL_PRO_ENTERPRISE = "http://merchant.xhngyl.net"
    BASEURL_PRO_GATEWAY = "/blade-gateway"
    SERVICE_MANAGE = "/platform-manage"
    download = 'dev'
    break;
  //测试环境
  case 'dev':
    baseurl = '/api'
    BASEURL_PRO = '/blade-gateway/platform-uc'
    BASEURL_PRO2 = "http://adm.xhngyl.net/api/"
    BASEURL_PRO_ENTERPRISE = "http://merchant.xhngyl.net"
    BASEURL_PRO_GATEWAY = "/blade-gateway"
    SERVICE_MANAGE = "/platform-manage"
    download = 'dev'
    break;
  //预发环境
  case 'pre':
    baseurl = '/api'
    BASEURL_PRO = '/blade-gateway/platform-uc'
    BASEURL_PRO2 = "http://adm.xhngyl.cn/api/"
    BASEURL_PRO_ENTERPRISE = "http://merchant.xhngyl.cn"
    BASEURL_PRO_GATEWAY = "/blade-gateway"
    SERVICE_MANAGE = "/platform-manage"
    download = 'pre'
    break;
  default:
    baseurl = '/api'
    BASEURL_PRO = '/blade-gateway/platform-uc'
    BASEURL_PRO2 = "http://adm.xhngyl.net/api/"
    BASEURL_PRO_ENTERPRISE = "http://merchant.xhngyl.net"
    BASEURL_PRO_GATEWAY = "/blade-gateway"
    SERVICE_MANAGE = "/platform-manage"
    download = 'dev'
    break;
}

Vue.prototype.baseurl = baseurl

Vue.prototype.$http = axios


// WEBPACK FOOTER //
// ./src/modules/http.js